// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"804":"app-oficina","966":"app-chofer"}[chunkId] || chunkId) + "." + {"13":"a6fc9e56","239":"5c4b3bbb","395":"13928820","455":"d2a825c6","544":"5c092862","804":"31778007","966":"7a5b0def","977":"e30e0df5"}[chunkId] + ".chunk.js";
};